import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { CloseButton } from "~/components/AssetModalV2/Header/components/CloseButton";
import { Header } from "~/components/AssetModalV2/Header/components/Header";
import { PublicBoardAssetNavigationArrows } from "~/components/AssetModalV2/Header/PublicBoardAssetComponents/PublicBoardAssetNavigationArrows";
import { PublicBoardAssetShareButton } from "~/components/AssetModalV2/Header/PublicBoardAssetComponents/PublicBoardAssetShareButton";
import { useCloseAssetModal } from "~/components/AssetModalV2/hooks/useCloseAssetModal";
import { TemporaryAssetModalHeader } from "~/components/AssetModalV2/TemporaryPlaceholderLayout";
export const PublicBoardAssetHeader = /*#__PURE__*/ memo(()=>{
    const { closeAssetModal } = useCloseAssetModal();
    return /*#__PURE__*/ _jsx(Header, {
        headerLeft: /*#__PURE__*/ _jsx(TemporaryAssetModalHeader, {}),
        headerRight: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ _jsx(PublicBoardAssetShareButton, {}),
                /*#__PURE__*/ _jsx(PublicBoardAssetNavigationArrows, {}),
                /*#__PURE__*/ _jsx(CloseButton, {
                    onClose: closeAssetModal
                })
            ]
        })
    });
});
PublicBoardAssetHeader.displayName = "PublicBoardAssetHeader";
